import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { SecurityTypeService } from '../../security/security.service';
import { Popover } from 'primeng/popover';
import {
  toggleEllipsisPopover,
  getEllipsisOptionValue,
} from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import { buttonStatus } from '../../../shared/constants/button-class';
import { roleEllipsisHeaderOptions, ellipsisRowOptions } from '../../security/security-ellipsis';
import { KeyMap } from '../../../shared/interface/key-map.interface';
import { v4 as uuidv4 } from 'uuid';
import { Subscription } from 'rxjs';
import { copy } from '../../../shared/utilities/common-utilities';
import { FormField } from '../../../shared/form-field/form-field';
import { ContractFormFieldService } from '../../../services/contract-form-field.service';
import { FormCanDeactivate } from '../../../shared/form-field/form-can-deactivate';

@Component({
  standalone: false,
  selector: 'admin-security-roles',
  templateUrl: 'sec-roles.template.html',
  providers: [SecurityTypeService, ContractFormFieldService],
})
export class SecurityRolesComponent extends FormCanDeactivate implements OnInit {
  formModalInfo: FormField<any>[] = [];
  cols: any[];
  header: string;
  dataList: any[];
  selectedItem: any;
  btnStatus: any = buttonStatus;
  ellipsisHeaderOptions: any[] = copy(roleEllipsisHeaderOptions);
  ellipsisRowOptions: any[] = ellipsisRowOptions;
  clonedRowData: KeyMap = {};
  isEditing: boolean;
  editConstant: string;
  displayAdd: boolean;
  displayUpdate: boolean;
  @Input() searchParams: any;

  constructor(
    private configurationService: SecurityTypeService,
    private contractService: ContractFormFieldService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
    this.displayAdd = false;
    this.displayUpdate = false;
  }

  isLoading = true;
  querySubscription: Subscription;

  ngOnInit() {
    this.editConstant = uuidv4();
    const tableValues = [];
    const roleNameFilter = this.getRoleNameFilter();
    this.querySubscription = this.configurationService.getRoleDetails(roleNameFilter).subscribe(
      ({ data, loading }: any) => {
        this.isLoading = loading;
        for (const singleRole of data.getAdminSettingRoles) {
          tableValues.push({ role_id: singleRole.role_id, role_name: singleRole.role_name });
        }
        this.dataList = tableValues;
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        throw err;
      },
    );

    this.cols = [{ field: 'role_name', header: 'ROLE NAME', type: 'text' }];
    this.contractService
      .getSecFormModalFields()
      .subscribe((formModalInfo) => (this.formModalInfo = formModalInfo));
  }

  // Opening the menu item passes the tab name as a string; a sidebar search passes the form payload.
  private getRoleNameFilter(): string {
    const roleName =
      this.searchParams && typeof this.searchParams === 'object'
        ? this.searchParams.rolename
        : null;
    const trimmedRoleName = typeof roleName === 'string' ? roleName.trim() : '';
    return trimmedRoleName ? `%${trimmedRoleName}%` : '%';
  }

  ellipsisClick(event, item, popover: Popover) {
    this.selectedItem = item;
    toggleEllipsisPopover(event, popover);
  }

  ellipsisOptionClick(event, popover: Popover) {
    popover.hide();
  }

  handleOpen(event, popover: Popover) {
    const value = getEllipsisOptionValue(event);

    if (value === 'Add Role') {
      this.header = 'Add Role';
      this.displayAdd = true;
    } else if (value === 'update') {
      this.header = 'Update Role';
      this.displayUpdate = true;
    }

    popover.hide();
    this.cdr.detectChanges();
  }

  onRowEdit() {
    this.isEditing = true;
    document.getElementById(this.editConstant + this.selectedItem.id).click();
  }

  onRowEditInit(rowData: any) {
    this.clonedRowData[rowData.id] = { ...rowData };
  }

  onRowEditSave(rowData: any) {
    delete this.clonedRowData[rowData.id];
    this.isEditing = false;
  }

  onRowEditCancel(rowData: any, index: number) {
    this.dataList[index] = this.clonedRowData[rowData.id];
    delete this.clonedRowData[rowData.id];
    this.isEditing = false;
  }

  onYes() {
    this.displayAdd = false;
    this.displayUpdate = false;
    this.cdr.detectChanges();
  }
}
